const React = require('react');

module.exports = ({text}) => {
  return (
    <h1 className="m0 p0 f23 lh22 fw7">{text}</h1>
  )
}
